import React, { Component, Fragment } from "react";
import axios from "../../../../../axios-order";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './Loader.css'

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
  Paper,
  Button,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Box,
  Typography,
  Tab,
  Tabs,
  AppBar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
} from "@material-ui/core";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "react-bootstrap/Modal";
import { ValidatorForm } from "react-material-ui-form-validator";
import SelectField from "../../../../../components/ui/basicSelectInput";
import BasicInputField from "../../../../../components/ui/basicInput";
import ValidatedDatePicker from "../../../../../components/ui/monthWiseDatePicker";
import ValidatedMonthAndYearPicker from "../../../../../components/ui/monthWiseDatePicker";
import Summary from "./summary";
import moment from "moment";
import MatchedInvoice from "./MatchedInvoice";
import MismatchedInvoice from "./MisMatched";
import MissingInAccount from "./MissingInAccount";
import MissingInGSTR from "./MissingInGSTR";
import VendorInvoiceSummary from "./VendorInvoiceSummary";
import AllInvoiceRecon from "./AllInvoiceRecon";
import ProbableMatchedInvoice from "./ProbableMatched";
import CryptoJS from "crypto-js";
import BoxWrapper from "../../../../../components/ui/boxWrapper";
// import UnRegister from "./UnRegisteRcm";
// import UnRegisteRcm from "./UnRegisteRcm";

// ─── SSE utilities ────────────────────────────────────────────────────────────
import { generateUUID } from '../../../../../utils/sseUtils';
import { SSE_BASE_URL } from '../../../../../axios-order';
// ─────────────────────────────────────────────────────────────────────────────

const styles = function (theme) {
  return {
    root: {
      width: "400px",
    },
    tab: {
      [theme.breakpoints.up("md")]: {
        minWidth: "auto",
      },
    },
  };
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

class Showdetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allGST2aReconReportData: {
        matched: []
      },
      reconId: '',
      tabValue: 0,
      loading: true,
      urlValue: this.props.location.state.v || [],
      reconType: this.props.location.state.url,
      matchedInvoiceData: null,
      mismatchedInvoiceData: null,
      probablematchedData: null,
      missineAccountData: null,
      missingstr: null,
      Vendorsummarydata: null,
      allinvoicerecondata: null,
      unregisterrcm: null,
      isDownloading: false,
      progress: 0,
      new_id: '',
      selectedPeriod: '',
      isProcessing: false,
      processingMessage: '',
      showCustomModal: false,
      yearArr: [],
      financialYear: null,
      roundValue: 0,
      customRoundOff: "",
      trigarCustomRoundOff: false,
      errorMessage: "",
      colorForErrorMessage: "red",
      errorMessageDisplayStyle: "none",
      showLogsModal: false,
      logsData: [],
      isLoadingLogs: false,
      currentReconId: null,
      logsPage: 0,
      logsRowsPerPage: 10,
      checked: false,
      fromMonthAndYear: "",
      toMontAndYear: "",
      forDisplayingFromMonthAndYear: "",
      forDisplayingToMonthAndYear: "",
      fromMonthAndYearGSTR: "",
      toMontAndYearGSTR: "",
      forDisplayingFromMonthAndYearGSTR: "",
      forDisplayingToMonthAndYearGSTR: "",
      showZohoLogsModal: false,
      zohoLogsData: null,
      isLoadingZohoLogs: false,
      isPushingZoho: false,
    };
  }

  getPeriodOptions = () => {
    if (this.state.reconType.toLowerCase() === 'gstr8a') {
      return [
        { id: "previous_fy", value: "Previous Financial Year" },
        { id: "current_fy", value: "Current Financial Year" },
        { id: "custom", value: "Custom" }
      ];
    }

    return [
      { id: "current_month", value: "Current Month" },
      { id: "previous_month", value: "Previous Month" },
      { id: "current_quarter", value: "Current Quarter" },
      { id: "previous_quarter", value: "Previous Quarter" },
      { id: "current_fy", value: "Current Financial Year" },
      { id: "previous_fy", value: "Previous Financial Year" },
      { id: "custom", value: "Custom" }
    ];
  };

  handlePeriodChange = (event) => {
    const selectedPeriod = event.target.value;
    this.setState({ selectedPeriod });
    if (selectedPeriod === "custom") {
      this.handleOpenCustomModal();
    }
  };

  // ─── SSE helper ──────────────────────────────────────────────────────────────

  initiateReconSSE = (sseToken) => {
    return new Promise((resolve, reject) => {
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }

      console.log("SSE Starting point");

      const url = `${SSE_BASE_URL}/api/sse/${sseToken}`;
      this.eventSource = new EventSource(url);

      console.log(
        "SSE object created:",
        url,
        "readyState:",
        this.eventSource.readyState
      );

      this.eventSource.onopen = () => {
        this._sseOpened = true;
        console.log('SSE onopen fired, readyState:', this.eventSource.readyState);
        resolve();
      };

      this.eventSource.onmessage = (event) => {
        console.log("RAW SSE:", event.data);
        try {
          const data = JSON.parse(event.data);
          console.log("REAL SSE DATA:", data);
          if (data.status === "done" || data.status === "Pass") {
            console.log("Recon completed via SSE, recon_id:", data.recon_id);
            if (this.eventSource) {
              this.eventSource.close();
              this.eventSource = null;
            }
            // ── VERIFY: check your backend log for the exact field name ──
            const reconId = data.recon_id
              || (this.state.reconType.toLowerCase() === 'gstr8a' ? data.gstr8a_recon_id : data.gstr2b_recon_id);
            this.fetchDetailedReport(reconId);
          }
        } catch (err) {
          console.log("Ignoring non-json SSE message:", event.data);
        }
      };

      this.eventSource.onerror = (e) => {
        const rs = this.eventSource?.readyState;
        console.log(
          "SSE onerror fired, readyState:", rs,
          "timestamp:", new Date().toISOString()
        );
        if (rs === 2) {
          console.log("SSE permanently closed (readyState 2)");
          if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
          }
          if (!this._sseOpened) {
            reject(new Error("SSE connection failed permanently"));
          }
        }
      };
    });
  };

  // ─── Run Report (preset periods) ─────────────────────────────────────────────

  handleRunReport = async () => {
    const { selectedPeriod, allGST2aReconReportData } = this.state;
    if (this.state.isProcessing) return;

    try {
      this.setState({ isProcessing: true, processingMessage: 'Opening SSE connection...' });
      this._sseOpened = false;
      const sseToken = generateUUID();

      // STEP 1 — Wait until SSE actually opens
      await this.initiateReconSSE(sseToken);
      console.log('SSE confirmed open. Starting recon POST.');
      this.setState({ processingMessage: 'Reconciliation started. Waiting for result...' });

      const requestData = {
        org_gstin: localStorage.getItem('gst') || allGST2aReconReportData.entity_details?.gstin,
        report_type: this.state.reconType.toLowerCase(),
        threshold_value: allGST2aReconReportData.entity_details?.Threshold_Value?.toString() || "5",
        period_type: selectedPeriod,
        sse_token: sseToken,
        functionality: this.state.reconType.toLowerCase() === 'gstr8a' ? 'GSTR8A Recon' : 'GSTR2B Recon',
      };

      // STEP 2 — Start recon only AFTER SSE is open
      const res = await axios.post(`/unified_auto_reconciliation`, requestData);
      console.log('Recon API response:', res.data);

      if (!res.data || res.data.status === false) {
        if (this.eventSource) { this.eventSource.close(); this.eventSource = null; }
        this.setState({ isProcessing: false, processingMessage: '' });
        toast.error('Failed to initiate reconciliation', { position: "top-right", autoClose: 4000 });
        return;
      }

      toast.info('Reconciliation initiated. Waiting for result...', { position: "top-right", autoClose: 4000 });

    } catch (err) {
      console.error('handleRunReport error:', err);
      if (this.eventSource) { this.eventSource.close(); this.eventSource = null; }
      this.setState({ isProcessing: false, processingMessage: '' });
      toast.error('Error initiating reconciliation', { position: "top-right", autoClose: 4000 });
    }
  };

  // ─── Custom Submit ────────────────────────────────────────────────────────────

  onSubmitHandlerForCustomPeriod = async () => {
    this.functionForErrorMessage("green", "block", "Loading....");

    let roundValueData;
    if (this.state.roundValue === 11) roundValueData = `${this.state.customRoundOff}`;
    else roundValueData = `${this.state.roundValue}`;

    this.setState({ showCustomModal: false, selectedPeriod: '', isProcessing: true, processingMessage: 'Opening SSE connection...' });

    try {
      this._sseOpened = false;
      const sseToken = generateUUID();

      // STEP 1 — Wait until SSE actually opens
      await this.initiateReconSSE(sseToken);
      console.log('SSE confirmed open. Starting recon POST.');
      this.setState({ processingMessage: 'Custom reconciliation started. Waiting for result...' });

      let payLoadData;

      if (this.state.reconType.toLowerCase() === 'gstr8a') {
        payLoadData = {
          'org_gstin': localStorage.getItem("gst") || this.state.allGST2aReconReportData.entity_details?.gstin,
          'report_type': this.state.reconType.toLowerCase(),
          'threshold_value': roundValueData,
          'financial_year': this.state.financialYear,
          period_type: "custom",
          sse_token: sseToken,
          functionality: 'GSTR8A Recon',
        };
      } else {
        payLoadData = {
          'org_gstin': localStorage.getItem("gst") || this.state.allGST2aReconReportData.entity_details?.gstin,
          'report_type': this.state.reconType.toLowerCase(),
          'threshold_value': roundValueData,
          'books_from_tax_period': this.state.fromMonthAndYear,
          'books_to_tax_period': this.state.toMontAndYear,
          'gstr_from_tax_period': this.state.checked ? this.state.fromMonthAndYearGSTR : this.state.fromMonthAndYear,
          'gstr_to_tax_period': this.state.checked ? this.state.toMontAndYearGSTR : this.state.toMontAndYear,
          period_type: "custom",
          sse_token: sseToken,
          functionality: 'GSTR2B Recon',
        };
      }

      // STEP 2 — Start recon only AFTER SSE is open
      const res = await axios.post(`/unified_auto_reconciliation`, payLoadData);
      console.log('Recon API response:', res.data);

      if (!res.data || res.data.status === false) {
        if (this.eventSource) { this.eventSource.close(); this.eventSource = null; }
        this.setState({ isProcessing: false, processingMessage: '' });
        toast.error('Failed to initiate custom reconciliation', { position: "top-right", autoClose: 4000 });
        return;
      }

      toast.info('Custom reconciliation initiated. Waiting for result...', { position: "top-right", autoClose: 4000 });

    } catch (err) {
      console.error('onSubmitHandlerForCustomPeriod error:', err);
      if (this.eventSource) { this.eventSource.close(); this.eventSource = null; }
      this.setState({ isProcessing: false, processingMessage: '' });
      toast.error('Error initiating custom reconciliation', { position: "top-right", autoClose: 4000 });
    }
    this.handleCloseCustomModal();
  };

  // ─── Fetch & update report ────────────────────────────────────────────────────

  fetchDetailedReport = (reconId) => {
    console.log("fetchDetailedReport called with:", reconId);
    if (!reconId) {
      this.setState({ isProcessing: false, processingMessage: '' });
      toast.error('No recon ID received from SSE.', { position: "top-right", autoClose: 4000 });
      return;
    }
    axios
      .get(`/${this.state.reconType.toLowerCase()}/summary/${reconId}`)
      .then((res) => {
        if (res.data.status && res.data.record && !Array.isArray(res.data.record)) {
          this.updateReportData(res.data, reconId);
        } else {
          this.setState({ isProcessing: false, processingMessage: '' });
          toast.error('Failed to fetch report. Please refresh.', { position: "top-right", autoClose: 4000 });
        }
      })
      .catch(() => {
        this.setState({ isProcessing: false, processingMessage: '' });
        toast.error('Error loading report data.', { position: "top-right", autoClose: 4000 });
      });
  };

  updateReportData = (responseData, reconId) => {
    this.setState({
      allGST2aReconReportData: responseData.record,
      new_id: reconId,
      reconId: reconId,
      currentReconId: reconId,
      isProcessing: false,
      processingMessage: '',
      loading: false,
      tabValue: 0,
    });

    toast.success("Reconciliation completed successfully!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  // ─── Lifecycle ────────────────────────────────────────────────────────────────

  async componentDidMount() {
    const decrypt = (data) => {
      return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
    };

    let activeUrl = window.location.href;
    let id = activeUrl.split("/");
    const reconId = decrypt(id[4]);

    try {
      const summaryResponse = await axios.get(`/${this.state.reconType.toLowerCase()}/summary/${reconId}`);

      if (summaryResponse.data && summaryResponse.data.record) {
        this.setState({
          allGST2aReconReportData: summaryResponse.data.record,
          new_id: reconId,
          reconId: reconId,
          loading: false,
        });
      } else {
        throw new Error('No record data found');
      }
    } catch (error) {
      console.error('Error loading specific recon:', error);

      try {
        const payload = {
          business_entity_id: parseInt(localStorage.getItem("business_entity_id")),
          org_gstin: localStorage.getItem("gst"),
          report_type: this.state.reconType.toLowerCase()
        };

        const latestRecordsResponse = await axios.post("/get_latest_recon_records", payload);

        if (latestRecordsResponse.data.status === true && latestRecordsResponse.data.data?.recon_id) {
          const latestReconId = latestRecordsResponse.data.data.recon_id;
          const verifyResponse = await axios.get(`/${this.state.reconType.toLowerCase()}/summary/${latestReconId}`);

          if (verifyResponse.data && verifyResponse.data.record) {
            const encrypt = (text) => {
              return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text.toString()));
            };

            const newUrl = `/${this.state.reconType.toLowerCase()}ReconciliationReport/${encrypt(latestReconId)}`;
            window.history.replaceState(null, '', newUrl);

        this.setState({
              allGST2aReconReportData: verifyResponse.data.record,
              new_id: latestReconId,
              reconId: latestReconId,
          loading: false,
        });
          } else {
            throw new Error('Failed to verify latest record');
          }
        } else {
          this.setState({ loading: false });
        }
      } catch (fallbackError) {
        console.error('Fallback error:', fallbackError);
        this.setState({ loading: false });
      }
    }
  }

  componentWillUnmount() {
    // Close SSE connection if component unmounts while processing
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
  }

  // ─── Logs ─────────────────────────────────────────────────────────────────────

  handleOpenLogsModal = () => {
    this.setState({ showLogsModal: true, isLoadingLogs: true });
    this.fetchReconLogs();
  };

  handleCloseZohoLogsModal = () => {
    this.setState({ showZohoLogsModal: false, zohoLogsData: null });
  };

  fetchReconLogs = () => {
    const org_gstin = localStorage.getItem('gst') || this.state.allGST2aReconReportData.entity_details?.gstin;
  
    axios
      .post(`/${this.state.reconType.toLowerCase()}_recon_summary`, {
        org_gstin: org_gstin
      })
      .then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          this.setState({
            logsData: res.data.data,
            isLoadingLogs: false
          });
        } else {
          this.setState({
            logsData: [],
            isLoadingLogs: false
          });
        }
      })
      .catch((error) => {
        console.error('Error fetching logs:', error);
        this.setState({ isLoadingLogs: false });
        toast.error('Failed to fetch reconciliation logs', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        });
      });
  };

  handleExportLog = (reconId) => {
    const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `${this.state.reconType.toLowerCase()}_recon_${reconId}.xlsx`;

    axios
      .get(`/only${this.state.reconType.toLowerCase()}report/summary/${reconId}`, {
        responseType: 'blob',
      })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.size === 0) {
            console.error("No data available");
            toast.warning("No data available for export", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            });
            return;
          }

          const blob = new Blob([res.data], { type: contentType });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      })
      .catch((error) => {
        console.error('Export error:', error);
        toast.error('Failed to export report', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        });
      });
  };

  handleViewReport = (reconId) => {
    const encrypt = (text) => {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text.toString()));
    };

    this.props.history.push({
      pathname: `/${this.state.reconType.toLowerCase()}ReconciliationReport/${encrypt(reconId)}`,
      state: {
        v: reconId,
        url: this.state.reconType.toLowerCase()
      },
    });
  };

  handlePushToZohoBooks = () => {
    const orgCode = localStorage.getItem("business_entity_id");

    this.setState({ isPushingZoho: true });

    // STEP 1 — Push recon to Zoho
    axios
      .post(`/zoho/push_recon_to_zoho`, {
        recon_id: this.state.new_id,
        org_code: orgCode,
      })
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message || "Recon push to Zoho initiated!", {
            position: "top-right", autoClose: 3000,
          });

          this.setState({
            isPushingZoho: false,
            showZohoLogsModal: true,
            isLoadingZohoLogs: true,
            zohoLogsData: null,
          });

          return axios.get(`/zoho/push_logs/${this.state.new_id}/${orgCode}`);
        } else {
          this.setState({ isPushingZoho: false });
          toast.error(res.data.message || "Failed to push to Zoho Books", {
            position: "top-right", autoClose: 5000,
          });
          return null;
        }
      })
      .then((res) => {
        if (!res) return;
        const data = res.data.data || null;
        this.setState({
          zohoLogsData: data,
          isLoadingZohoLogs: false,
        });

        if (data?.zoho_status === "Failed" && data?.error_message) {
          toast.error(data.error_message, {
            position: "top-right", autoClose: 5000,
          });
        }
      })
      .catch((err) => {
        console.error("Zoho error:", err);
        this.setState({ isPushingZoho: false, isLoadingZohoLogs: false });
        toast.error("Failed to push to Zoho Books", {
          position: "top-right", autoClose: 3000,
        });
      });
  };

  handleZohoExportLog = () => {
    const reconId = this.state.new_id;
    if (!reconId) return;

    const filename = `zoho_push_logs_${reconId}.xlsx`;

    axios
      .get(`/zoho/push_logs/download/${reconId}`)
      .then((res) => {
        const { file, status } = res.data;

        if (status !== "pass" || !file) {
          toast.warning("No data available for export", {
            position: "top-right", autoClose: 3000,
          });
          return;
        }

        const byteCharacters = atob(file);
        const byteNumbers = new Array(byteCharacters.length)
          .fill(null)
          .map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        toast.error("Failed to export Zoho push logs", {
          position: "top-right", autoClose: 3000,
        });
      });
  };

handleRefreshZohoLogs = () => {
  const orgCode = localStorage.getItem("business_entity_id");
  const reconId = this.state.zohoLogsData?.recon_id || this.state.new_id;

  this.setState({ isLoadingZohoLogs: true });

  axios
    .get(`/zoho/push_logs/refresh/${reconId}/${orgCode}`)
    .then((res) => {
      const data = res.data.data || null;
      this.setState({
        zohoLogsData: data,
        isLoadingZohoLogs: false,
      });

      if (data?.zoho_status === "Failed" && data?.error_message) {
        toast.error(data.error_message, {
          position: "top-right", autoClose: 5000,
        });
      }

      toast.success("Zoho logs refreshed!", {
        position: "top-right", autoClose: 2000,
      });
    })
    .catch(() => {
      this.setState({ isLoadingZohoLogs: false });
      toast.error("Failed to refresh Zoho logs", {
        position: "top-right", autoClose: 3000,
      });
    });
};

  handleCloseLogsModal = () => {
    this.setState({ showLogsModal: false, logsData: [], logsPage: 0 });
  };

  // ─── All original helpers unchanged ──────────────────────────────────────────

  setFromYearValues = () => {
    let current_year = new Date().getFullYear();
    let yearArr1 = [];
    for (let i = current_year - 7; i <= current_year + 5; i++) {
      let startYear = i;
      let endYear = i + 1;
      let endYearShort = endYear.toString().slice(-2);
      yearArr1.push({ id: `${startYear}-${endYearShort}`, value: `${startYear}-${endYearShort}` });
    }
    this.setState({ yearArr: yearArr1 });
  };

  functionForErrorMessage = (color, displays, message) => {
    this.setState({
      errorMessage: message,
      colorForErrorMessage: color,
      errorMessageDisplayStyle: displays
    });
  };

  inputHandlerForFinancialYear = (event) => {
    let value = event.target.value;
    this.setState({ financialYear: value });
  };

  roundValueInputHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "threshold_value" && value === 11) {
      this.setState({
        roundValue: value,
        trigarCustomRoundOff: true,
      });
    } else if (name === "threshold_value") {
      this.setState({
        roundValue: value,
        trigarCustomRoundOff: false,
      });
    } else if (name === "customRoundOff") {
      this.setState({ customRoundOff: value });
    }
  };

  downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  downloadToExcel = () => {
    const { new_id } = this.state;
    const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `gst_recon2b_export.xlsx`;

    const startTime = performance.now();

    this.setState({ isDownloading: true, progress: 0 });

    axios
      .get(`/only${this.state.reconType.toLowerCase()}report/summary/${new_id}`, {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          const progress = (progressEvent.loaded / progressEvent.total) * 100;
          this.setState({ progress });
        },
      })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.size === 0) {
            console.error("No data available");
            this.setState({ isDownloading: false });
            return;
          }

          const blob = new Blob([res.data], { type: contentType });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();

          const endTime = performance.now();
          const timeTaken = (endTime - startTime) / 1000;
        } else {
          console.error("Error occurred while fetching the data");
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.setState({ isDownloading: false });
      });
  };

  handleTabChangeHandler = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

handleTabChange = (event, newValue) => {
  this.setState({ tabValue: newValue });
};

  handleTabChan = (event, newValue) => {
    this.setState({ tabValue: newValue })
  }

handleMatchedInvoiceTabClick = async () => {
  try {
    const { new_id } = this.state;
      const response = await axios.get(`/${this.state.reconType.toLowerCase()}_dashboard_summary_for_matched_invoices/${this.state.new_id}`);
    const data = response.data;
    this.setState({ matchedInvoiceData: data });
    console.log('API Response:', data);
  } catch (error) {
    console.error('API Error:', error);
  }
};

handleMatchedInvoiceTabCli = async () => {
   try {
    const { new_id } = this.state;
      const response = await axios.get(`/${this.state.reconType.toLowerCase()}_dashboard_summary_for_mismatched_invoices/${this.state.new_id}`);
    const data = response.data;
    this.setState({ mismatchedInvoiceData: data });
    console.log('API Response:', data);
  } catch (error) {
    console.error('API Error:', error);
  }
}

  handleProbableMatch = async () => {
  try {
  const { new_id } = this.state;
      const response = await axios.get(`/${this.state.reconType.toLowerCase()}_dashboard_summary_for_probablematch_invoices/${this.state.new_id}`);
   const data = response.data;
   this.setState({ probablematchedData: data });
   console.log('API Response:', data);
 } catch (error) {
   console.error('API Error:', error);
 }
}

handleMissingAccount = async () => {
   try {
    const { new_id } = this.state;
      const response = await axios.get(`/${this.state.reconType.toLowerCase()}_dashboard_summary_for_missing_in_books/${this.state.new_id}`);
    const data = response.data;
    this.setState({ missineAccountData: data });
    console.log('API Response:', data);
  } catch (error) {
    console.error('API Error:', error);
  }
}

handleMissingGSTR = async () => {
   try {
    const { new_id } = this.state;
      const response = await axios.get(`/${this.state.reconType.toLowerCase()}_dashboard_summary_for_missing_in_${this.state.reconType.toLowerCase()}/${this.state.new_id}`);
    const data = response.data;
    this.setState({ missingstr: data });
    console.log('API Response:', data);
  } catch (error) {
    console.error('API Error:', error);
  }
}

handleVoiceSummary = async () => {
  try {
    const { new_id } = this.state;
      const response = await axios.get(`/${this.state.reconType.toLowerCase()}_dashboard_summary_vendor_summary/${this.state.new_id}`);
    const data = response.data;
      this.setState({ Vendorsummarydata: data });
    console.log('API Response:', data);
  } catch (error) {
    console.error('API Error:', error);
  }
}

  handleallvoiceRecon = async () => {
   try {
    const { new_id } = this.state;
      const response = await axios.get(`/${this.state.reconType.toLowerCase()}_dashboard_summary_all_invoice/${this.state.new_id}`);
    const data = response.data;
      this.setState({ allinvoicerecondata: data });
    console.log('API Response:', data);
  } catch (error) {
    console.error('API Error:', error);
  }
}

  handlealunRegisterRcm = async () => {
    try {
      const { new_id } = this.state;
      const response = await axios.get(`/${this.state.reconType.toLowerCase()}_dashboard_summary_for_unregistered_rcm/${this.state.new_id}`);
      const data = response.data;
      this.setState({ unregisterrcm: data });
      console.log('API Response:', data);
    } catch (error) {
      console.error('API Error:', error);
    }
  }

  handleBack = () => {
    this.props.history.push('/reconCards');
  };

  handleCloseCustomModal = () => {
    this.setState({
      showCustomModal: false,
      selectedPeriod: '',
      financialYear: null,
      roundValue: 0,
      customRoundOff: "",
      trigarCustomRoundOff: false,
      errorMessage: "",
      errorMessageDisplayStyle: "none",
      checked: false,
      fromMonthAndYear: "",
      toMontAndYear: "",
      forDisplayingFromMonthAndYear: "",
      forDisplayingToMonthAndYear: "",
      fromMonthAndYearGSTR: "",
      toMontAndYearGSTR: "",
      forDisplayingFromMonthAndYearGSTR: "",
      forDisplayingToMonthAndYearGSTR: "",
    });
  };

  handleChangeCheckbox = () => {
    this.setState({ checked: !this.state.checked });
  };

  inputHandlerForYearAndFromMonth = (v) => {
    this.setState({ forDisplayingFromMonthAndYear: v });
    const current_date = new Date(v);
    const yy = current_date.getFullYear().toString();
    const mm = (current_date.getMonth() + 1).toString();

    let MonthAndYear;
    if (mm < 10) {
      MonthAndYear = `0${mm}${yy}`;
    } else {
      MonthAndYear = `${mm}${yy}`;
    }
    this.setState({ fromMonthAndYear: MonthAndYear });
  };

  inputHandlerForYearAndToMonth = (v) => {
    this.setState({ forDisplayingToMonthAndYear: v });
    const current_date = new Date(v);
    const yy = current_date.getFullYear().toString();
    const mm = (current_date.getMonth() + 1).toString();

    let toMonthAndYear;
    if (mm < 10) {
      toMonthAndYear = `0${mm}${yy}`;
    } else {
      toMonthAndYear = `${mm}${yy}`;
    }
    this.setState({ toMontAndYear: toMonthAndYear });
  };

  inputHandlerForYearAndFromMonthGSTR = (v) => {
    this.setState({ forDisplayingFromMonthAndYearGSTR: v });
    const current_date = new Date(v);
    const yy = current_date.getFullYear().toString();
    const mm = (current_date.getMonth() + 1).toString();

    let MonthAndYear;
    if (mm < 10) {
      MonthAndYear = `0${mm}${yy}`;
    } else {
      MonthAndYear = `${mm}${yy}`;
    }
    this.setState({ fromMonthAndYearGSTR: MonthAndYear });
  };

  inputHandlerForYearAndToMonthGSTR = (v) => {
    this.setState({ forDisplayingToMonthAndYearGSTR: v });
    const current_date = new Date(v);
    const yy = current_date.getFullYear().toString();
    const mm = (current_date.getMonth() + 1).toString();

    let toMonthAndYear;
    if (mm < 10) {
      toMonthAndYear = `0${mm}${yy}`;
    } else {
      toMonthAndYear = `${mm}${yy}`;
    }
    this.setState({ toMontAndYearGSTR: toMonthAndYear });
  };

  handleOpenCustomModal = () => {
    this.setFromYearValues();
    this.setState({ showCustomModal: true });
  };

  render() {
    const { classes } = this.props;
    const { isDownloading, progress } = this.state;
    const isRolling = progress === 0;
    const { matchedInvoiceData, mismatchedInvoiceData, Vendorsummarydata, probablematchedData, missineAccountData, missingstr, allinvoicerecondata, unregisterrcm } = this.state;
    const periodOptions = this.getPeriodOptions();
 
    return (
      <React.Fragment>
        <ToastContainer />
          {this.state.loading === true && (
            <div style={{ textAlign: "center", marginTop: 50 }}>
              <CircularProgress />
              <br></br>
              Loading,Please wait...
            </div>
          )}

          {this.state.loading === false && (
            <>
            <div style={{
              backgroundColor: "#f5f5f5",
              padding: "15px 20px",
              marginBottom: "0px"
            }}>
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={3}>
                  <div style={{ fontSize: "12px", lineHeight: "1.8", marginBottom: "8px" }}>
                    Report Dated: {moment(
                      this.state.allGST2aReconReportData.entity_details?.Reconciliation_Date
                    ).format("DD-MM-YYYY")}
                    <br />
                    Threshold Used: {this.state.allGST2aReconReportData.entity_details?.Threshold_Value}
                  </div>
                  <button
                    className="button-outlined-primary"
                    style={{ padding: "6px 20px", fontSize: "13px" }}
                    onClick={this.handleBack}
                  >
                    BACK
                  </button>
                </Grid>

                <Grid item xs={6}>
                  <div style={{ textAlign: "center" }}>
                    <div style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      marginBottom: "12px",
                      color: "#333"
                    }}>
                      {this.state.reconType.toUpperCase()} Reconciliation Report
                    </div>
                    <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                      <style>{`
  @keyframes spin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
`}</style>

                    <button
                      className="button-outlined-primary"
                      onClick={this.downloadToExcel}
                        disabled={isDownloading}
                        style={{
                          padding: "6px 24px",
                          fontSize: "13px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          opacity: isDownloading ? 0.85 : 1,
                          cursor: isDownloading ? "not-allowed" : "pointer"
                        }}
                      >
                        {isDownloading ? (
                          <>
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              style={{ animation: "spin 0.9s linear infinite", flexShrink: 0 }}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="8" cy="8" r="6"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeDasharray="28"
                                strokeDashoffset="10"
                                strokeLinecap="round"
                              />
                            </svg>
                            EXPORTING...
                          </>
                        ) : (
                          "EXPORT TO EXCEL"
                        )}
                      </button>
                      <button
                        className="button-outlined-primary"
                        onClick={this.handleOpenLogsModal}
                        style={{ padding: "6px 24px", fontSize: "13px" }}
                      >
                        LOGS
                      </button>

                      {this.state.reconType.toLowerCase() === 'gstr2b' && (
                        <button
                          className="button-outlined-primary"
                          onClick={this.handlePushToZohoBooks}
                          disabled={this.state.isPushingZoho}
                          style={{
                            padding: "6px 24px",
                            fontSize: "13px",
                            backgroundColor: "#e8f5e9",
                            borderColor: "#388e3c",
                            color: "#388e3c",
                          }}
                        >
                          {this.state.isPushingZoho ? "PUSHING..." : "PUSH TO ZOHO BOOKS"}
                    </button>
        )}
          </div>
                  </div>
                </Grid>

                <Grid item xs={3}>
                  <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    gap: "10px"
                  }}>
                    <div style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center"
                    }}>
                      <FormControl
                        variant="outlined"
                        size="small"
                        style={{
                          minWidth: "180px",
                          backgroundColor: "#fff"
                        }}
                      >
                        <InputLabel></InputLabel>
                        <Select
                          value={this.state.selectedPeriod}
                          onChange={this.handlePeriodChange}
                          label="Period"
                          disabled={this.state.isProcessing}
                          displayEmpty
                        >
                          <MenuItem value="" disabled>
                            <em>Select Period</em>
                          </MenuItem>
                          {periodOptions.map(option => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleRunReport}
                        disabled={this.state.isProcessing || !this.state.selectedPeriod}
                        style={{
                          padding: "8px 20px",
                          fontWeight: "600",
                          whiteSpace: "nowrap"
                        }}
                      >
                        {this.state.isProcessing ? "PROCESSING..." : "RUN REPORT"}
                      </Button>
                    </div>

                    {this.state.isProcessing && (
                      <div style={{
                        marginTop: "4px",
                        padding: "8px 12px",
                        backgroundColor: "#e3f2fd",
                        borderRadius: "4px",
                        fontSize: "11px",
                        color: "#1976d2",
                        textAlign: "right",
                        border: "1px solid #90caf9"
                      }}>
                        {this.state.processingMessage}
                  </div>
                    )}

                    <div style={{
                      fontSize: "11px",
                      textAlign: "right",
                      lineHeight: "1.6",
                      color: "#666"
                    }}>
                      Books Period: {this.state.allGST2aReconReportData.entity_details?.books_period}
                      <br />
                      GSTR Period: {this.state.allGST2aReconReportData.entity_details?.gstr_period}
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>

              {/* tab panel */}
              <div className={classes.TabPanelSection}>
                <AppBar position="static" color="default">
                  <Tabs
                    value={this.state.tabValue}
                    onChange={this.handleTabChangeHandler}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                  >
                    <Tab
                      classes={{ root: classes.tab }}
                      style={{ background: "#fff", color: "#000" }}
                      label="Summary "
                      {...a11yProps(0)}
                    />
                    <Tab
                      classes={{ root: classes.tab }}
                      style={{ background: "#28a745", color: "#000" }}
                      label="Matched Invoices"
                      {...a11yProps(1)}
                    />
                    <Tab
                      classes={{ root: classes.tab }}
                      style={{ background: "red", color: "#fff" }}
                      label="Mismatch Invoices"
                      {...a11yProps(2)}
                    />
                    <Tab
                      classes={{ root: classes.tab }}
                      style={{ background: "#ddd", color: "#000" }}
                      label="Probable Match"
                      {...a11yProps(3)}
                    />
                    <Tab
                      classes={{ root: classes.tab }}
                      style={{ background: "#ffad33", color: "#000" }}
                      label="Missing in Accounts"
                      {...a11yProps(4)}
                    />
                    <Tab
                      classes={{ root: classes.tab }}
                      style={{ background: "#ffbf80", color: "#000" }}
                    label={`Missing in ${this.state.reconType.toUpperCase()}`}
                      {...a11yProps(5)}
                    />
                    <Tab
                      classes={{ root: classes.tab }}
                      style={{ background: "#b3d9ff", color: "#000" }}
                      label="Vendor wise Summary"
                      {...a11yProps(6)}
                    />
                  <Tab
                    classes={{ root: classes.tab }}
                    style={{ background: "#5be3c8", color: "#000" }}
                    label="UnRegistered Rcm"
                    {...a11yProps(7)}
                  />
                    <Tab
                      classes={{ root: classes.tab }}
                      style={{ background: "#ffff4d", color: "#000" }}
                      label="All Invoice(s) Recon"
                    {...a11yProps(8)}
                    />
                  </Tabs>
                </AppBar>

                {/*  Summary Dashboard */}
                <TabPanel value={this.state.tabValue} index={0}>
                  <BoxWrapper boxTitle="Summary">
                    <Summary
                      SummaryData={
                        this.state.allGST2aReconReportData.gstSummaryDashBoard
                      }
                    />
                  </BoxWrapper>
                </TabPanel>

              <TabPanel value={this.state.tabValue} index={1}>
                  <MatchedInvoice
    matchedInvoiceData={matchedInvoiceData}
     onTabClick={this.handleMatchedInvoiceTabClick}
  />
                </TabPanel>

    <TabPanel value={this.state.tabValue} index={2} onChange={this.handleTabChange}>
                  <MismatchedInvoice
                  onTabClick={this.handleMatchedInvoiceTabCli}
                  mismatchedInvoiceData={mismatchedInvoiceData}
                  />
                </TabPanel>

                  <TabPanel value={this.state.tabValue} index={3} onChange={this.handleTabChange}>
                  <ProbableMatchedInvoice
                    onTabClick={this.handleProbableMatch}
                    probablematchedData={probablematchedData}
                  />
                </TabPanel>

                   <TabPanel value={this.state.tabValue} index={4} onChange={this.handleTabChange}>
                  <MissingInAccount
                    onTabClick={this.handleMissingAccount}
                    missineAccountData={missineAccountData}
                  />
                </TabPanel>

           <TabPanel value={this.state.tabValue} index={5} onChange={this.handleTabChange}>
                  <MissingInGSTR
                  onTabClick={this.handleMissingGSTR}
                  missingstr={missingstr}
                  />
                </TabPanel>

                <TabPanel value={this.state.tabValue} index={6} onChange={this.handleTabChange}>
                  <VendorInvoiceSummary
                   onTabClick={this.handleVoiceSummary}
                   Vendorsummarydata={Vendorsummarydata}  
                  />
                </TabPanel>

              {/* <TabPanel value={this.state.tabValue} index={7} onChange={this.handleTabChange}>
                <UnRegisteRcm
                  onTabClick={this.handlealunRegisterRcm}
                  unregisterrcm={unregisterrcm}
                  />
              </TabPanel> */}

              <TabPanel value={this.state.tabValue} index={8} onChange={this.handleTabChange}>
                  <AllInvoiceRecon
                     onTabClick={this.handleallvoiceRecon}
                     allinvoicerecondata={allinvoicerecondata}
                  />
                </TabPanel>
              </div>
            </>
          )}

        {/* ── Logs Modal ── */}
        <Modal
          size="xl"
          centered
          show={this.state.showLogsModal}
          onHide={this.handleCloseLogsModal}
          style={{ maxWidth: "90vw" }}
        >
          <Modal.Header
            closeButton
            style={{
              padding: '14px 20px',
              backgroundColor: '#03406d',
              borderBottom: 'none'
            }}
          >
            <Modal.Title style={{
              display: 'flex',
              alignItems: 'center',
              fontSize: '1rem',
              fontWeight: 600,
              color: '#fff'
            }}>
              <span style={{ marginRight: '8px' }}>⟲</span>
              {this.state.reconType.toUpperCase()} Reconciliation Logs
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: 0 }}>
            {this.state.isLoadingLogs ? (
              <div style={{
                textAlign: "center",
                padding: "40px"
              }}>
                <CircularProgress />
                <div style={{ fontSize: "14px", color: "#666", marginTop: "10px" }}>Loading logs...</div>
              </div>
            ) : this.state.logsData.length === 0 ? (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <div style={{ fontSize: "14px", color: "#999" }}>No logs available</div>
              </div>
            ) : (
              <div style={{
                overflowX: "auto",
                maxHeight: "500px",
                overflowY: "auto"
              }}>
                <table style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "13px"
                }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f5f5f5" }}>
                      <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", fontSize: "11px", color: "#666", textTransform: "uppercase", borderBottom: "1px solid #ddd" }}>
                        Books From Month
                      </th>
                      <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", fontSize: "11px", color: "#666", textTransform: "uppercase", borderBottom: "1px solid #ddd" }}>
                        Books To Month
                      </th>
                      <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", fontSize: "11px", color: "#666", textTransform: "uppercase", borderBottom: "1px solid #ddd" }}>
                        GSTR From Month
                      </th>
                      <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", fontSize: "11px", color: "#666", textTransform: "uppercase", borderBottom: "1px solid #ddd" }}>
                        GSTR To Month
                      </th>
                      <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", fontSize: "11px", color: "#666", textTransform: "uppercase", borderBottom: "1px solid #ddd" }}>
                        Recon Date
                      </th>
                      <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", fontSize: "11px", color: "#666", textTransform: "uppercase", borderBottom: "1px solid #ddd" }}>
                        GSTIN
                      </th>
                      <th style={{ padding: "12px 16px", textAlign: "center", fontWeight: "600", fontSize: "11px", color: "#666", textTransform: "uppercase", borderBottom: "1px solid #ddd" }}>
                        Threshold
                      </th>
                      <th style={{ padding: "12px 16px", textAlign: "center", fontWeight: "600", fontSize: "11px", color: "#666", textTransform: "uppercase", borderBottom: "1px solid #ddd" }}>
                        Status
                      </th>
                      <th style={{ padding: "12px 16px", textAlign: "center", fontWeight: "600", fontSize: "11px", color: "#666", textTransform: "uppercase", borderBottom: "1px solid #ddd" }}>
                        Export
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.logsData
                      .slice(
                        this.state.logsPage * this.state.logsRowsPerPage,
                        this.state.logsPage * this.state.logsRowsPerPage + this.state.logsRowsPerPage
                      )
                      .map((log, index) => (
                        <tr
                          key={log.recon_id || index}
                          style={{
                            borderBottom: "1px solid #f0f0f0",
                            backgroundColor: index % 2 === 0 ? "#fff" : "#fafafa"
                          }}
                        >
                          <td style={{ padding: "12px 16px", color: "#555" }}>
                            {moment(log.books_from_tax_period, "MMYYYY").format("MMMM-YYYY")}
                          </td>
                          <td style={{ padding: "12px 16px", color: "#555" }}>
                            {moment(log.books_to_tax_period, "MMYYYY").format("MMMM-YYYY")}
                          </td>
                          <td style={{ padding: "12px 16px", color: "#555" }}>
                            {moment(log.gstr_from_tax_period, "MMYYYY").format("MMMM-YYYY")}
                          </td>
                          <td style={{ padding: "12px 16px", color: "#555" }}>
                            {moment(log.gstr_to_tax_period, "MMYYYY").format("MMMM-YYYY")}
                          </td>
                          <td style={{ padding: "12px 16px", color: "#555" }}>
                            {log.recon_date}
                          </td>
                          <td style={{ padding: "12px 16px", color: "#555" }}>
                            {log.org_gstin}
                          </td>
                          <td style={{ padding: "12px 16px", textAlign: "center", color: "#555" }}>
                            {log.tval !== undefined && log.tval !== null ? log.tval : "-"}
                          </td>
                          <td style={{ padding: "12px 16px", textAlign: "center" }}>
                            <span style={{
                              padding: "4px 12px",
                              borderRadius: "12px",
                              fontSize: "11px",
                              fontWeight: "600",
                              display: "inline-block",
                              textTransform: "uppercase",
                              backgroundColor: log.status === "Pass" ? "#d4edda" : "#f8d7da",
                              color: log.status === "Pass" ? "#155724" : "#721c24"
                            }}>
                              {log.status || "Pass"}
                            </span>
                          </td>
                          <td style={{ padding: "12px 16px", textAlign: "center" }}>
                            {log.status === "Pass" ? (
                              <button
                                onClick={() => this.handleExportLog(log.recon_id)}
                                disabled={this.state.isLoadingLogs}
                                style={{
                                  padding: "6px 10px",
                                  backgroundColor: "#28a745",
                                  color: "#fff",
                                  border: "none",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  fontSize: "11px"
                                }}
                              >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ verticalAlign: "middle" }}>
                                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                  <polyline points="7 10 12 15 17 10"></polyline>
                                  <line x1="12" y1="15" x2="12" y2="3"></line>
                                </svg>
                              </button>
                            ) : (
                              <span style={{ color: "#999" }}>-</span>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer style={{
            padding: '12px 20px',
            borderTop: '1px solid #ddd',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div style={{ fontSize: "12px", color: "#666" }}>
              Rows per page:
              <select
                value={this.state.logsRowsPerPage}
                onChange={(e) => {
                  this.setState({
                    logsRowsPerPage: parseInt(e.target.value, 10),
                    logsPage: 0
                  });
                }}
                style={{
                  marginLeft: '8px',
                  padding: '4px 8px',
                  border: '1px solid #ccc',
                  borderRadius: '3px',
                  fontSize: '12px'
                }}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
              </select>
              <span style={{ marginLeft: '16px' }}>
                {this.state.logsPage * this.state.logsRowsPerPage + 1}–
                {Math.min((this.state.logsPage + 1) * this.state.logsRowsPerPage, this.state.logsData.length)} of {this.state.logsData.length}
              </span>
            </div>

            <div style={{ display: 'flex', gap: '6px' }}>
              <button
                onClick={() => this.setState({ logsPage: this.state.logsPage - 1 })}
                disabled={this.state.logsPage === 0}
                style={{
                  padding: '4px 10px',
                  border: '1px solid #ccc',
                  borderRadius: '3px',
                  backgroundColor: '#fff',
                  cursor: this.state.logsPage === 0 ? 'not-allowed' : 'pointer',
                  opacity: this.state.logsPage === 0 ? 0.5 : 1
                }}
              >
                ‹
              </button>
              <button
                onClick={() => this.setState({ logsPage: this.state.logsPage + 1 })}
                disabled={(this.state.logsPage + 1) * this.state.logsRowsPerPage >= this.state.logsData.length}
                style={{
                  padding: '4px 10px',
                  border: '1px solid #ccc',
                  borderRadius: '3px',
                  backgroundColor: '#fff',
                  cursor: (this.state.logsPage + 1) * this.state.logsRowsPerPage >= this.state.logsData.length ? 'not-allowed' : 'pointer',
                  opacity: (this.state.logsPage + 1) * this.state.logsRowsPerPage >= this.state.logsData.length ? 0.5 : 1
                }}
              >
                ›
              </button>
            </div>

            <button
              onClick={this.handleCloseLogsModal}
              style={{
                padding: '6px 20px',
                border: '1px solid #ccc',
                borderRadius: '3px',
                backgroundColor: '#fff',
                cursor: 'pointer',
                fontSize: '12px',
                textTransform: 'uppercase',
                fontWeight: '500'
              }}
            >
              CLOSE
            </button>
          </Modal.Footer>
        </Modal>

        {/* ── Custom Period Modal ── */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showCustomModal}
          onHide={this.handleCloseCustomModal}
          dialogClassName="modal-50w"
        >
          <Modal.Header closeButton className="modal-header" style={{ backgroundColor: '#03406d', color: '#fff' }}>
            <Modal.Title className="modal-title" style={{ fontSize: '1rem', fontWeight: 600 }}>
              {this.state.reconType.toUpperCase()} Reconciliation
            </Modal.Title>
          </Modal.Header>

          <ValidatorForm
            ref="form"
            onSubmit={this.onSubmitHandlerForCustomPeriod}
            onError={(errors) => console.log(errors)}
          >
            <Modal.Body>
              {this.state.reconType.toLowerCase() === 'gstr8a' && (
                <div style={{ padding: "0px 20px 20px 20px" }}>
                  <Grid container spacing={3}>
                    <Grid item sm={3}>
                      <p style={{ fontSize: "16px" }}>
                        Select Financial Year
                        <span style={{ color: "red" }}>*</span>:
                      </p>
                    </Grid>
                    <Grid item sm={9}>
                      <SelectField
                        validator={["required"]}
                        errorMsg={["This field is required"]}
                        choice_id="id"
                        choice_name="value"
                        name="year"
                        value={this.state.financialYear}
                        choices={this.state.yearArr}
                        textOnchangeFunction={this.inputHandlerForFinancialYear}
                      />
                    </Grid>
                  </Grid>
                </div>
              )}

              {this.state.reconType.toLowerCase() === 'gstr2b' && (
                <>
                  <div style={{ padding: "0px 20px 10px 20px" }}>
                    <Grid item sm={12} container>
                      <Checkbox
                        checked={this.state.checked}
                        onChange={this.handleChangeCheckbox}
                      />
                      <p onClick={this.handleChangeCheckbox} style={{ marginTop: "10px", fontSize: "16px", cursor: 'pointer' }}>
                        Advanced Criteria
                      </p>
                    </Grid>
                  </div>

                  <div style={{ padding: "0px 20px 20px 20px" }}>
                    <Grid container spacing={2}>
                      {this.state.checked && (
                        <Grid item sm={12}>
                          <p style={{ marginTop: "14px", fontSize: "16px", fontWeight: "600" }}>
                            Books Period :
                          </p>
                        </Grid>
                      )}

                      <Grid item sm={3}>
                        <p style={{ marginTop: "14px", fontSize: "16px" }}>
                          From Month<span style={{ color: "red" }}>*</span>:
                        </p>
                      </Grid>
                      <Grid item sm={3}>
                        <div style={{ marginTop: "10px" }}>
                          <ValidatedDatePicker
                            placeholder="Month & Year"
                            errorMessages={["This field is required"]}
                            validators={["required"]}
                            value={this.state.forDisplayingFromMonthAndYear}
                            onChange={(v) => this.inputHandlerForYearAndFromMonth(v)}
                          />
                        </div>
                      </Grid>

                      <Grid item sm={3}>
                        <p style={{ marginTop: "14px", fontSize: "16px" }}>
                          To Month<span style={{ color: "red" }}>*</span>:
                        </p>
                      </Grid>
                      <Grid item sm={3}>
                        <div style={{ marginTop: "10px" }}>
                          <ValidatedMonthAndYearPicker
                            minDateForDatepicker={this.state.forDisplayingFromMonthAndYear}
                            errorMessages={["This field is required"]}
                            validators={["required"]}
                            placeholder="Month & Year"
                            value={this.state.forDisplayingToMonthAndYear}
                            onChange={(v) => this.inputHandlerForYearAndToMonth(v)}
                          />
                        </div>
                      </Grid>

                      {this.state.checked && (
                        <>
                          <Grid item sm={12}>
                            <p style={{ marginTop: "14px", fontSize: "16px", fontWeight: "600" }}>
                              GSTR-2B Period :
                            </p>
                          </Grid>

                          <Grid item sm={3}>
                            <p style={{ marginTop: "14px", fontSize: "16px" }}>
                              From Month<span style={{ color: "red" }}>*</span>:
                            </p>
                          </Grid>
                          <Grid item sm={3}>
                            <div style={{ marginTop: "10px" }}>
                              <ValidatedDatePicker
                                placeholder="Month & Year"
                                errorMessages={["This field is required"]}
                                validators={["required"]}
                                value={this.state.forDisplayingFromMonthAndYearGSTR}
                                onChange={(v) => this.inputHandlerForYearAndFromMonthGSTR(v)}
                              />
                            </div>
                          </Grid>

                          <Grid item sm={3}>
                            <p style={{ marginTop: "14px", fontSize: "16px" }}>
                              To Month<span style={{ color: "red" }}>*</span>:
                            </p>
                          </Grid>
                          <Grid item sm={3}>
                            <div style={{ marginTop: "10px" }}>
                              <ValidatedMonthAndYearPicker
                                minDateForDatepicker={this.state.forDisplayingFromMonthAndYearGSTR}
                                errorMessages={["This field is required"]}
                                validators={["required"]}
                                placeholder="Month & Year"
                                value={this.state.forDisplayingToMonthAndYearGSTR}
                                onChange={(v) => this.inputHandlerForYearAndToMonthGSTR(v)}
                              />
                            </div>
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </div>
                </>
              )}

              {/* For non-gstr2b, non-gstr8a recon types show standard from/to month pickers */}
              {this.state.reconType.toLowerCase() !== 'gstr2b' && this.state.reconType.toLowerCase() !== 'gstr8a' && (
                <div style={{ padding: "0px 20px 20px 20px" }}>
                  <Grid container spacing={2}>
                    <Grid item sm={3}>
                      <p style={{ marginTop: "14px", fontSize: "16px" }}>
                        From Month<span style={{ color: "red" }}>*</span>:
                      </p>
                    </Grid>
                    <Grid item sm={3}>
                      <div style={{ marginTop: "10px" }}>
                        <ValidatedDatePicker
                          placeholder="Month & Year"
                          errorMessages={["This field is required"]}
                          validators={["required"]}
                          value={this.state.forDisplayingFromMonthAndYear}
                          onChange={(v) => this.inputHandlerForYearAndFromMonth(v)}
                        />
                      </div>
                    </Grid>

                    <Grid item sm={3}>
                      <p style={{ marginTop: "14px", fontSize: "16px" }}>
                        To Month<span style={{ color: "red" }}>*</span>:
                      </p>
                    </Grid>
                    <Grid item sm={3}>
                      <div style={{ marginTop: "10px" }}>
                        <ValidatedMonthAndYearPicker
                          minDateForDatepicker={this.state.forDisplayingFromMonthAndYear}
                          errorMessages={["This field is required"]}
                          validators={["required"]}
                          placeholder="Month & Year"
                          value={this.state.forDisplayingToMonthAndYear}
                          onChange={(v) => this.inputHandlerForYearAndToMonth(v)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </div>
              )}

              <div style={{ padding: "0px 20px 20px 20px" }}>
                <Grid container spacing={3}>
                  <Grid item sm={3}>
                    <p style={{ fontSize: "16px" }}>
                      Threshold value<span style={{ color: "red" }}>*</span>:
                    </p>
                  </Grid>
                  <Grid item sm={9}>
                    <SelectField
                      validator={["required"]}
                      errorMsg={["This field is required"]}
                      choice_id="id"
                      choice_name="roundOff"
                      name="threshold_value"
                      value={this.state.roundValue ?? 0}
                      choices={[
                        { id: 0, roundOff: "No Threshold Value" },
                        { id: 1, roundOff: "Upto 1" },
                        { id: 5, roundOff: "Upto 5" },
                        { id: 10, roundOff: "Upto 10" },
                        { id: 11, roundOff: "Custom" },
                      ]}
                      textOnchangeFunction={this.roundValueInputHandler}
                    />
                  </Grid>
                </Grid>
              </div>

              {this.state.trigarCustomRoundOff && (
                <div style={{ padding: "0px 20px 20px 20px", marginTop: "10px" }}>
                  <Grid container spacing={3}>
                    <Grid item sm={3}>
                      <p style={{ marginTop: "30px", fontSize: "16px" }}>
                        Custom Round off
                        <span style={{ color: "red" }}>*</span> :
                      </p>
                    </Grid>
                    <Grid item sm={9}>
                      <BasicInputField
                        inputType="number"
                        name="customRoundOff"
                        validator={["required"]}
                        errorMsg={["This field is required"]}
                        value={this.state.customRoundOff ?? ""}
                        textOnchangeFunction={this.roundValueInputHandler}
                      />
                    </Grid>
                  </Grid>
                </div>
              )}

              <div
                style={{
                  color: this.state.colorForErrorMessage,
                  paddingTop: "10px",
                  paddingLeft: "20px",
                  fontWeight: "600",
                  display: this.state.errorMessageDisplayStyle,
                }}
              >
                {this.state.errorMessage}
              </div>
            </Modal.Body>

            <Modal.Footer>
              <button
                className="button-primary"
                type="submit"
                style={{ marginRight: "10px" }}
                disabled={this.state.isProcessing}
              >
                {this.state.isProcessing ? "PROCESSING..." : "SUBMIT"}
              </button>
              <button
                className="button-outlined-secondary"
                type="button"
                onClick={this.handleCloseCustomModal}
                disabled={this.state.isProcessing}
              >
                CLOSE
              </button>
            </Modal.Footer>
          </ValidatorForm>
        </Modal>
        {/* ── Zoho Push Logs Modal ── */}
        <Modal
          size="lg"
          centered
          show={this.state.showZohoLogsModal}
          onHide={this.handleCloseZohoLogsModal}
        >
          <Modal.Header
            closeButton
            style={{ padding: "14px 20px", backgroundColor: "#03406d", borderBottom: "none" }}
          >
            <Modal.Title style={{
              fontSize: "1rem", fontWeight: 600, color: "#fff",
              display: "flex", alignItems: "center", gap: "8px", width: "100%",
              justifyContent: "space-between"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span>📋</span> Zoho Books — Push Logs
              </div>
              <button
                onClick={this.handleRefreshZohoLogs}
                disabled={this.state.isLoadingZohoLogs}
                title="Refresh"
                style={{
                  marginRight: "8px",
                  padding: "4px 10px",
                  backgroundColor: "transparent",
                  border: "1px solid rgba(255,255,255,0.5)",
                  borderRadius: "4px",
                  color: "#fff",
                  cursor: this.state.isLoadingZohoLogs ? "not-allowed" : "pointer",
                  opacity: this.state.isLoadingZohoLogs ? 0.6 : 1,
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  fontSize: "12px",
                }}
              >
                <svg
                  width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2.5"
                  style={{
                    animation: this.state.isLoadingZohoLogs ? "spin 0.9s linear infinite" : "none"
                  }}
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
                </svg>
                REFRESH
              </button>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: "20px" }}>
            {this.state.isLoadingZohoLogs ? (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <CircularProgress />
                <div style={{ fontSize: "14px", color: "#666", marginTop: "10px" }}>
                  Loading Zoho push logs...
                </div>
              </div>
            ) : !this.state.zohoLogsData ? (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <div style={{ fontSize: "14px", color: "#999" }}>No Zoho push logs available</div>
              </div>
            ) : (
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                <thead>
                  <tr style={{ backgroundColor: "#f5f5f5" }}>
                    {["Total Records", "Passed", "Failed", "Zoho Status", "Pushed At", "Export"].map((h) => (
                      <th key={h} style={{
                        padding: "12px 16px",
                        textAlign: "left",
                        fontWeight: "600",
                        fontSize: "11px",
                        color: "#666",
                        textTransform: "uppercase",
                        borderBottom: "1px solid #ddd",
                        whiteSpace: "nowrap"
                      }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ borderBottom: "1px solid #f0f0f0" }}>
                    <td style={{ padding: "12px 16px", textAlign: "center", color: "#555" }}>
                      {this.state.zohoLogsData.total_records ?? "-"}
                    </td>
                    <td style={{ padding: "12px 16px", textAlign: "center" }}>
                      <span style={{
                        padding: "3px 10px", borderRadius: "12px", fontSize: "11px",
                        fontWeight: "600", backgroundColor: "#d4edda", color: "#155724"
                      }}>
                        {this.state.zohoLogsData.passed_records ?? 0}
                      </span>
                    </td>
                    <td style={{ padding: "12px 16px", textAlign: "center" }}>
                      <span style={{
                        padding: "3px 10px", borderRadius: "12px", fontSize: "11px",
                        fontWeight: "600", backgroundColor: "#f8d7da", color: "#721c24"
                      }}>
                        {this.state.zohoLogsData.failed_records ?? 0}
                      </span>
                    </td>
                    <td style={{ padding: "12px 16px", textAlign: "center" }}>
                      <span style={{
                        padding: "4px 12px", borderRadius: "12px", fontSize: "11px",
                        fontWeight: "600", display: "inline-block", textTransform: "uppercase",
                        backgroundColor:
                          this.state.zohoLogsData.zoho_status === "Success" ? "#d4edda"
                            : this.state.zohoLogsData.zoho_status === "Failed" ? "#f8d7da"
                              : "#fff3cd",
                        color:
                          this.state.zohoLogsData.zoho_status === "Success" ? "#155724"
                            : this.state.zohoLogsData.zoho_status === "Failed" ? "#721c24"
                              : "#856404"
                      }}>
                        {this.state.zohoLogsData.zoho_status || "-"}
                      </span>
                    </td>
                    <td style={{ padding: "12px 16px", color: "#555", whiteSpace: "nowrap" }}>
                      {this.state.zohoLogsData.pushed_at || "-"}
                    </td>
                    <td style={{ padding: "12px 16px", textAlign: "center" }}>
                      {/* Wire up export API when ready */}
                      <button
                        onClick={this.handleZohoExportLog}
                        style={{
                          padding: "6px 10px", backgroundColor: "#28a745",
                          color: "#fff", border: "none", borderRadius: "4px",
                          cursor: "pointer", fontSize: "11px"
                        }}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" strokeWidth="2" style={{ verticalAlign: "middle" }}>
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                          <polyline points="7 10 12 15 17 10"></polyline>
                          <line x1="12" y1="15" x2="12" y2="3"></line>
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
          </Modal.Body>

          <Modal.Footer style={{
            padding: "12px 20px", borderTop: "1px solid #ddd",
            display: "flex", justifyContent: "flex-end"
          }}>
            <button
              onClick={this.handleCloseZohoLogsModal}
              style={{
                padding: "6px 20px", border: "1px solid #ccc", borderRadius: "3px",
                backgroundColor: "#fff", cursor: "pointer", fontSize: "12px",
                textTransform: "uppercase", fontWeight: "500"
              }}
            >
              CLOSE
            </button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

Showdetails.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Showdetails);